import Heading from "components/heading/Heading";

const Achievements = ({ data }) => {
    return (
        <div className="achievements details-section" id="achievements">
            <Heading>Achievements</Heading>
            <ul>
                {data.map((v, i) => {
                    return (
                        <li className="info-list-item" key={v}>
                            <p>{v}</p>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
export default Achievements;
